import styled from 'styled-components'
import React from 'react'

export const Page = styled.div`
  width: 414px;
  background-color: ${props => props.theme.colors.white};
`
